import React, { useContext, useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { Table, Input } from 'antd'
import AdminToggle from 'views/UserManagement/Projects/components/EditableUsers/AdminToggle'
import { NoData } from 'components'
import { freeSearch } from 'utils/search'
import { ProjectsContext } from 'views/UserManagement/Projects'
import InProjectToggle from 'views/UserManagement/Projects/components/EditableUsers/InProjectToggle'

const { Search } = Input

const SEARCH_USERS_MAPPING = {
  name: 'name',
  surname: 'surname'
}
const StyledProjectUsers = styled.div({
  marginTop: 20,
  maxHeight: 350,
  overflowY: 'auto'
})

const getColumns = () => [
  {
    title: 'In Project',
    dataIndex: 'in_project',
    render: (_, record) => <InProjectToggle record={record} />
  },
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name)
  },
  {
    title: 'Surname',
    dataIndex: 'surname',
    sorter: (a, b) => a.surname.localeCompare(b.surname)
  },
  {
    title: 'Admin',
    dataIndex: 'is_admin',
    render: (_, record) => <AdminToggle record={record} />
  }
]

const ProjectUsers = props => {
  const { possibleUsers, form } = useContext(ProjectsContext)
  const [searchData, setSearchData] = useState(possibleUsers)

  const handleSearch = term => {
    console.log(form.getFieldsValue())
    if (term && term.length) setSearchData(freeSearch(searchData, term, SEARCH_USERS_MAPPING))
    else {
      setSearchData(possibleUsers)
    }
  }

  useEffect(() => {
    if (possibleUsers) {
      setSearchData(possibleUsers)
    }
  }, [possibleUsers])
  return (
    <>
      <Search placeholder="search user" onChange={event => handleSearch(event.target.value)} />
      <StyledProjectUsers>
        <Table
          rowKey="id"
          columns={getColumns()}
          dataSource={searchData}
          size="small"
          pagination={false}
          locale={{
            emptyText: <NoData />
          }}
        />
      </StyledProjectUsers>
    </>
  )
}

export default ProjectUsers
